module.exports = {"title":"Yay!","description":"<p>Your Global Price Setting has been applied to all dates.</p>","ok":"Ok"}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/ConfirmGlobalChange/locales/fr.json
// module id = 1678
// module chunks = 0